<script>
  import { onMount, onDestroy, createEventDispatcher } from "svelte";
  import MyModal from "../components/MyModal.svelte";
  import RestJumpseatRequests from "../components/RestJumpseatRequests.svelte";
  import { appSession } from "../stores/app.js";
  import { DateTime } from "luxon";
  import JSRequestFormatter from "../components/JSRequestFormatter.svelte";
  import JumpseatRequestEdit from "./JumpSeatRequestEdit.svelte";
  import { navigate } from "svelte-routing";
  import RestPilots from "../components/RestPilots.svelte";

//  const dispatch = createEventDispatcher();

  let busy = false;
  let myModal;
  let restJumpseatRequests;
  let restPilots;
  let requests = null;
  let jumpseatRequestId = null;
  let refreshTimer = null;

  onMount(async () => {
    try {
      busy = true;

      requests = await loadRequests();

      refreshTimer = setInterval(async () => {
        if (jumpseatRequestId != null) return;

        requests = await loadRequests();
      }, 60000);

      busy = false;
    } catch (error) {
      busy = false;

      switch (error) {
        case "BadRole":
        case "BadRealm":
          appSession.set({ authorisationToken: null, pilotId: null });
          break;
        case "NetworkError":
          myModal.showAlert(
            "Network error",
            "A network error occurred.<p> Check network connection and try again.</p>"
          );
          break;
        default:
          myModal.showAlert("Error", error);
          break;
      }
    }
  });

  onDestroy(() => {
    if (refreshTimer) clearInterval(refreshTimer);
  });

  async function loadRequests() {
    let requests = await restJumpseatRequests.GetJumpseatRequestList(
      "fields=jumpseatrequestid,status,emptyleg&order=datetime"
    );
    requests.forEach((request) => {
      request.emptyleg.datetime = DateTime.fromSQL(request.emptyleg.datetime);
      request.emptyleg.datetimelocal = DateTime.fromSQL(request.emptyleg.datetimelocal);
      const gmtDiff = request.emptyleg.datetimelocal.diff(request.emptyleg.datetime, "hours");
      gmtDiff.toObject();
      request.emptyleg.gmtoffset = gmtDiff.as("hours") < 0 ? gmtDiff.as("hours") : "+" + gmtDiff.as("hours");
    });

    return requests;
  }

  async function welcomeShown() {
    try {
      let fields = {
        welcomed: 1,
      };
      await restPilots.PutPilots($appSession.pilotId, fields);
    } catch (error) {
      switch (error) {
        case "BadRole":
        case "BadRealm":
          appSession.set({ authorisationToken: null, pilotId: null });
          break;
        case "NetworkError":
          myModal.showAlert(
            "Network error",
            "A network error occurred.<p> Check network connection and try again.</p>"
          );
          break;
        default:
          myModal.showAlert("Error", error);
          break;
      }
    }
  }
</script>

{#if jumpseatRequestId == null}
  {#if busy}
    <div
      style="display: flex; justify-content: center; align-items: center; height: 50px; width: 100%; margin-top: 100px;"
    >
      <div class="preloader-wrapper small active">
        <div class="spinner-layer spinner-green-only">
          <div class="circle-clipper left">
            <div class="circle" />
          </div>
          <div class="gap-patch">
            <div class="circle" />
          </div>
          <div class="circle-clipper right">
            <div class="circle" />
          </div>
        </div>
      </div>
    </div>
  {/if}

  {#if !busy}
    {#if requests}
      {#if requests.length > 0}
        <table class="highlight requests" style="font-size: 0.19em; margin-top: 10px;">
          <tbody>
            {#each requests as request}
              <tr
                on:click={() => {
                  jumpseatRequestId = request.jumpseatrequestid;
                }}
              >
                <td>
                  <JSRequestFormatter status={request.status} emptyLeg={request.emptyleg} />
                </td>
              </tr>
            {/each}
          </tbody>
        </table>
      {:else}
        <div style="text-align: center; padding-top: 100px;">
          <p>No empty leg requests</p>
          <p>
            <button
              class="waves-effect waves-light btn-small blue-grey"
              on:click={() => {
                navigate("/search");
              }}
            >
              Search
            </button>
          </p>
        </div>
      {/if}
    {/if}
  {/if}
{/if}

{#if jumpseatRequestId}
  <JumpseatRequestEdit
    {jumpseatRequestId}
    on:close={async (e) => {
      jumpseatRequestId = null;
      if (e.detail.changed.requests) requests = await loadRequests();
    }}
  />
{/if}

<MyModal bind:this={myModal} />
<RestJumpseatRequests bind:this={restJumpseatRequests} />
<RestPilots bind:this={restPilots} />

<style>
  .requests {
    cursor: pointer;
    margin: 10px 0;
  }
</style>
